import React from 'react';
import { APP_META } from 'src/services/config';

const ZEAR_X_URL = 'https://x.com/Zear_Protocol';

const CommunityLinks = [
  {
    label: 'X',
    url: process.env.REACT_APP_TWITTER_URL || ZEAR_X_URL,
    icon: <XIcon />,
  },
];

function openUrl(url?: string) {
  if (!url) return;
  const openedWindow = window.open();
  if (!openedWindow) return;
  openedWindow.opener = null;
  openedWindow.location = url;
}

function Footer() {
  return (
    <div className="mt-auto w-full">
      <footer className="relative z-20 flex items-center justify-between px-8 py-4 text-xs text-primaryText">
        <div className="flex items-center">
          <span>2026 © {APP_META.name}</span>
          <div className="flex items-center space-x-3 ml-4">
            {CommunityLinks.map((link) => (
              <button
                key={link.label}
                type="button"
                title={link.label}
                className="inline-flex items-center justify-center"
                style={glassButtonStyle}
                onClick={() => openUrl(link.url)}
              >
                {link.icon}
              </button>
            ))}
          </div>
        </div>
      </footer>
    </div>
  );
}
const glassButtonStyle: React.CSSProperties = {
  width: 44,
  height: 44,
  borderRadius: 999,
  color: '#F4F7F8',
  fontSize: 16,
  background:
    'linear-gradient(180deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0.05) 42%, rgba(0,0,0,0.28) 100%)',
  border: '1px solid rgba(255, 255, 255, 0.22)',
  boxShadow:
    'inset 0 1px 0 rgba(255,255,255,0.45), inset 0 -10px 16px rgba(0,0,0,0.35), 0 8px 18px rgba(0,0,0,0.28)',
  backdropFilter: 'blur(16px)',
  WebkitBackdropFilter: 'blur(16px)',
};

function XIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.727-8.835L1.254 2.25H8.08l4.253 5.622L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

export default Footer;
